<h1 class="text-center">ESTRENOS</h1>
<div class="row" *ngIf="movies.length > 0">
    <div class="col">
        <app-slideshow [movies]="moviesSlideshow"></app-slideshow>
    </div>
</div>

<h3>PELÍCULAS EN LA DB</h3>
<div class="row">
    <div class="col">
        <app-peliculas-poster-grid [movies]="movies" *ngIf="movies.length > 0"></app-peliculas-poster-grid>
    </div>
</div>